import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../../shared/apiRoutes";
import HttpRoutingService from "../../shared/services/httpRoutingService";
//module
import { ModifierOption, modifierPayload, Modifierset, deleteModifierset, editModifierset, getAllModfier, getAllModfierset, getOneModfierSet, postModifierSetProps, postModifierset, optionExist } from "../../components/products/modifiers/modifierModule";

import { ZenToast } from "zen-core-elements";


export interface updateModifierOptionProps { optionValue: string, price: string, medium?: 'POS' }

export interface updateModifiersetProps { modifierName: string, alternateName: string | null, modifiers: postModifierSetProps, isDeleted: false, medium: 'POS' }

interface initialState {
    modifiers: {
        loading: boolean
        option: { value: ModifierOption[], count: number }
        set: { value: Modifierset[], count: number }
    }
}

const initialState: initialState = {
    modifiers: {
        loading: true,
        option: { value: [], count: 0 },
        set: { value: [], count: 0 }
    }
}

//Modifer options
export const getModifierOption = createAsyncThunk("modifer/getModifierOption", ({ storeId, payload }: modifierPayload) => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllModifier, { storeId: storeId })
    return HttpRoutingService?.getMethod<getAllModfier>(url, payload)
})

export const getModifierSet = createAsyncThunk("modifer/getModifierSet", ({ storeId, payload }: modifierPayload) => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllModfierSet, { storeId: storeId })
    return HttpRoutingService?.getMethod<getAllModfierset>(url, payload)
})

export const getOneModifierSet = createAsyncThunk("modifer/getOneModifierSet", ({ storeId, modifierId }: { storeId: number, modifierId: number }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getOneModifierSet, { storeId: storeId, modifierId: modifierId })
    return HttpRoutingService?.getMethod<getOneModfierSet>(url)
})

export const deleteModifierOption = createAsyncThunk("modifier/getModifierOption", ({ storeId, modifierId }: { storeId: number, modifierId: number | undefined }) => {
    const url = HttpRoutingService?.replaceUrl(API?.deleteModifierOption, { storeId: storeId, modifierId: modifierId })
    return HttpRoutingService?.deleteMethod<deleteModifierset>(url)
})

export const deleteModifierSet = createAsyncThunk("modifer/deleteModifierSet", ({ storeId, modifierId }: { storeId: number, modifierId: number }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getOneModifierSet, { storeId: storeId, modifierId: modifierId })
    return HttpRoutingService?.deleteMethod<deleteModifierset>(url)
})

export const updateModifierOption = createAsyncThunk("modifier/updateModifierOption", ({ storeId, modifierId, data }: { storeId: number, modifierId: number, data: updateModifierOptionProps }) => {
    const url = HttpRoutingService?.replaceUrl(API?.updateModifierOption, { storeId: storeId, modifierId: modifierId })
    return HttpRoutingService?.putMethod<editModifierset>(url, data)
})

export const updateModifierSet = createAsyncThunk("modifer/updateModifierSet", ({ storeId, modifierId, data }: { storeId: number, modifierId: number, data: updateModifiersetProps }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getOneModifierSet, { storeId: storeId, modifierId: modifierId })
    return HttpRoutingService?.putMethod<editModifierset>(url, data)
})

export const ModifierOptionExist = createAsyncThunk("modifier/optionExist", ({ storeId, id }: { storeId: number, id: number }) => {
    const url = HttpRoutingService?.replaceUrl(API?.optionExist, { storeId: storeId, modifierId: id })
    return HttpRoutingService?.getMethod<optionExist>(url, null, "v1/")
})

export const modifierSetExist = createAsyncThunk("modifier/modifierSetExist", ({ storeId, id }: { storeId: number, id: number }) => {
    const url = HttpRoutingService?.replaceUrl(API?.modifierSetExist, { storeId: storeId, modifierSetId: id })
    return HttpRoutingService?.getMethod<optionExist>(url, null, "v1/")
})

export const createModifierOption = createAsyncThunk("modifier/createModifierOption", ({ storeId, data }: { storeId: number, data: updateModifierOptionProps }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllPosModifiers, { storeId: storeId })
    return HttpRoutingService?.postMethod<postModifierset>(url, data)
})

export const createModifierSet = createAsyncThunk("modifer/createModifierSet", ({ storeId, data }: { storeId: number, data: updateModifiersetProps }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllModfierSet, { storeId: storeId })
    return HttpRoutingService?.postMethod<postModifierset>(url, data)
})




export const modifierSlice = createSlice({
    name: "modifier",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getModifierOption?.pending, (state) => {
                state.modifiers.loading = true
            })
            .addCase(getModifierOption?.fulfilled, (state, action) => {
                const { payload: { offset } } = action?.meta?.arg
                const { count = 0, rows = [] } = action.payload?.modifiers
                state.modifiers.loading = false
                state.modifiers.option.count = count

                if (offset == 0)
                    state.modifiers.option.value = rows || []
                else if (rows?.length)
                    state.modifiers.option.value = [...state.modifiers.option.value, ...rows]
            })
            .addCase(getModifierOption?.rejected, (state, action) => {
                state.modifiers.loading = false
                ZenToast({
                    type: "error",
                    message: "Failed to get modifier options"
                })
            })

            .addCase(getModifierSet.pending, (state) => {
                state.modifiers.loading = true
            })
            .addCase(getModifierSet.fulfilled, (state, action) => {
                const { payload: { offset } } = action?.meta?.arg
                const { count = 0, rows = [] } = action.payload?.modifierSet
                state.modifiers.loading = false
                state.modifiers.set.count = count

                if (offset == 0)
                    state.modifiers.set.value = rows || []
                else if (rows?.length)
                    state.modifiers.set.value = [...state.modifiers.set.value, ...rows]
            })
            .addCase(getModifierSet.rejected, (state, action) => {
                state.modifiers.loading = false
                ZenToast({
                    type: "error",
                    message: "Failed to get modifier set"
                })
            })

    }
})

export default modifierSlice?.reducer